module.exports = __webpack_public_path__ + "static/media/Len Statham Headshot_1606741002485.adebf24c.jpeg";